import request from '@/router/axios'
import BaseApi from '@/api/BaseApi';

let urlPrefix = '/api/lab/labexperiment2user'

export const update = (data = {}) => {
    return request(urlPrefix, { data }, 'put')
};

export const editReportContent = (data = {}) => {
    return request(`${urlPrefix}`, {
        data
    }, 'put');
};

// /lab/labexperiment2user/query
export const getStudentReports = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
        }
    });
};

//自动评分
export const getGraded = id => {
    return request(`${urlPrefix}/student/grade/${id}`, null, 'put')
};


class LabExperiment2UserApi extends BaseApi {
    BASE_PATH = '/api/lab/labexperiment2user'
        
    static instance() {
        if (this._instance) {
            return this._instance;
        }
        return new LabExperiment2UserApi();
    }
}

export default LabExperiment2UserApi.instance()